import React, { useCallback, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import get from 'get-value';
import TextField from 'modules/af_cm_ui_kit/components/TextField/TextField';
import { Props, FIELDS, FIELDS_LABELS } from './types';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { formatFullAddressOld } from 'utils/address';
import ChangeableFullAddress from './ChangeableFullAddress';

const ChangeableAddress: React.FC<Props> = ({ onChangeClick, addressValues, setFieldValue, prefix }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const { errors } = useFormikContext();

  const createFieldName = useCallback(
    (fieldName: string) => {
      if (prefix) {
        return `${prefix}.${fieldName}`;
      }
      return fieldName;
    },
    [prefix],
  );

  useEffect(() => {
    setFieldValue(createFieldName(FIELDS.FULL_ADDRESS), formatFullAddressOld(addressValues));
  }, [addressValues, setFieldValue, createFieldName]);

  const changeClickHandler = () => {
    setIsExpanded(false);

    const addressHandler = onChangeClick('address');

    return addressHandler(addressValues);
  };

  const onClick = () => {
    if (!isExpanded) {
      setIsExpanded(true);
    }
  };

  const checkAddressValidation = () => {
    const fields = [
      createFieldName(`address.${FIELDS.POSTCODE}`),
      createFieldName(`address.${FIELDS.HOUSE_NUMBER}`),
      createFieldName(`address.${FIELDS.ADDRESS_LINE_1}`),
      createFieldName(`address.${FIELDS.ADDRESS_LINE_2}`),
      createFieldName(`address.${FIELDS.CITY}`),
      createFieldName(`address.${FIELDS.COUNTY}`),
    ];

    for (let field of fields) {
      if (get(errors, field)) {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      <Field
        component={ChangeableFullAddress}
        name={createFieldName(FIELDS.FULL_ADDRESS)}
        title={FIELDS_LABELS.FULL_ADDRESS}
        onChangeClick={changeClickHandler}
        onClick={onClick}
        disabled={isExpanded}
        disabledButton={checkAddressValidation()}
        addressValues={addressValues}
      />

      {isExpanded && (
        <>
          <Field
            component={TextField}
            name={createFieldName(`address.${FIELDS.POSTCODE}`)}
            title={FIELDS_LABELS.POSTCODE}
            variant={VARIANTS_TYPES.POSTCODE}
          />

          <Field
            component={TextField}
            name={createFieldName(`address.${FIELDS.HOUSE_NUMBER}`)}
            title={FIELDS_LABELS.HOUSE_NUMBER}
          />

          <Field
            component={TextField}
            name={createFieldName(`address.${FIELDS.ADDRESS_LINE_1}`)}
            title={FIELDS_LABELS.ADDRESS_LINE_1}
          />

          <Field
            component={TextField}
            name={createFieldName(`address.${FIELDS.ADDRESS_LINE_2}`)}
            title={FIELDS_LABELS.ADDRESS_LINE_2}
          />

          <Field component={TextField} name={createFieldName(`address.${FIELDS.CITY}`)} title={FIELDS_LABELS.CITY} />

          <Field
            component={TextField}
            name={createFieldName(`address.${FIELDS.COUNTY}`)}
            title={FIELDS_LABELS.COUNTY}
          />
        </>
      )}
    </>
  );
};

export default ChangeableAddress;
